import ci1 from '@/assets/img/ci/1.svg';
import ci2 from '@/assets/img/ci/2.svg';
import ci3 from '@/assets/img/ci/3.svg';
import ci4 from '@/assets/img/ci/4.svg';
import ci5 from '@/assets/img/ci/5.svg';
import ci6 from '@/assets/img/ci/6.svg';
import ci7 from '@/assets/img/ci/7.svg';
import ci8 from '@/assets/img/ci/8.svg';
import ci9 from '@/assets/img/ci/9.svg';
import ci10 from '@/assets/img/ci/10.svg';
import ci11 from '@/assets/img/ci/11.svg';
import ci12 from '@/assets/img/ci/12.svg';
import ci13 from '@/assets/img/ci/13.svg';
import ci14 from '@/assets/img/ci/14.svg';
import ci15 from '@/assets/img/ci/15.svg';
import ci16 from '@/assets/img/ci/16.svg';
import ci17 from '@/assets/img/ci/17.svg';
import ci18 from '@/assets/img/ci/18.svg';
import ci19 from '@/assets/img/ci/19.svg';
import ci20 from '@/assets/img/ci/20.svg';
import ci21 from '@/assets/img/ci/21.svg';
import ci22 from '@/assets/img/ci/22.svg';
import ci23 from '@/assets/img/ci/23.svg';
import ci24 from '@/assets/img/ci/24.svg';
import ci25 from '@/assets/img/ci/25.svg';
import ci26 from '@/assets/img/ci/26.svg';
import ci27 from '@/assets/img/ci/27.svg';
import ci28 from '@/assets/img/ci/human.png';
import ci29 from '@/assets/img/ci/j2kbio.png';
import ci30 from '@/assets/img/ci/macrocare.png';
import ci_nordinary from '@/assets/img/ci/nordinary.png';
import ci31 from '@/assets/img/ci/samyang_kci.png';

import * as S from './style';

const sponsorGroups = [
	{
		grade: 'Platinum',
		logos: [
			{ image: ci1, name: '㈜아모레퍼시픽', url: 'https://www.apgroup.com/int/ko/' },
			{ image: ci2, name: '㈜LG생활건강', url: 'https://www.lghnh.com/index.jsp' },
			{ image: ci3, name: '선진뷰티사이언스', url: 'https://sunjinbs.co.kr/kor/main/' },
		],
	},
	{
		grade: 'Gold',
		logos: [
			{ image: ci4, name: '㈜한국콜마', url: 'https://www.kolmar.co.kr/' },
			{ image: ci5, name: '㈜코스맥스', url: 'https://www.cosmax.com/' },
			{ image: ci27, name: '코스메카코리아', url: 'https://www.cosmecca.com/ko/home' },
			{ image: ci6, name: '현대바이오랜드㈜', url: 'https://www.hyundaibioland.co.kr/main' },
			{ image: ci7, name: '한국암웨이㈜', url: 'https://www.amway.co.kr/main' },
			{ image: ci29, name: '제이투케이바이오', url: 'https://www.j2kbio.com/' },
		],
	},
	{
		grade: 'Silver',
		logos: [
			{ image: ci8, name: '바이오스펙트럼㈜', url: 'https://www.biospectrum.com/' },
			{ image: ci20, name: '대봉엘에스㈜', url: 'https://daebongls.co.kr/kor' },
			{ image: ci9, name: '에프아이씨씨 주식회사', url: 'https://firstinclass.co.kr/' },
			{ image: ci10, name: '엑티브온', url: 'https://www.activon.kr/' },
			{ image: ci11, name: '태경SBC', url: 'http://www.taekyungsbc.co.kr/pc/main;jsessionid=EC581B9AC1A2CFFF316E389C9A18CA82' },
			{ image: ci12, name: '태경코엠', url: 'http://www.taekyungcoem.co.kr/pc/main;jsessionid=43F590AA6556C4E1D3BFFB3D044FBF94' },
			{ image: ci26, name: '지에프씨생명과학', url: 'https://www.gfcos.co.kr/' },
			{ image: ci28, name: '휴먼 임상시험센터', url: 'https://www.humantest.co.kr/index.html' },
		],
	},
	{
		grade: 'Bronze',
		logos: [
			{ image: ci13, name: '㈜잇츠한불', url: 'https://itshanbul.com/' },
			{ image: ci14, name: '㈜한국화장품', url: 'https://www.hkcosm.com/00_main/main.jsp' },
			{ image: ci15, name: '㈜코스모코스', url: 'https://www.cosmocos.com/' },
			{ image: ci_nordinary, name: '㈜노디너리', url: 'https://www.nordinary.co.kr/' },
			{ image: ci16, name: '마리디엠피부과학연구소', url: 'https://www.mariedm.com/' },
			{ image: ci17, name: '모아캠', url: 'https://morechem.net/index.php' },
			{ image: ci18, name: '㈜엘리드', url: 'https://www.ellead.com/' },
			{ image: ci19, name: '㈜더마프로', url: 'http://www.dermapro.co.kr/' },
			{ image: ci21, name: '㈜세일인터네쇼날', url: 'http://www.seilint.com/inc_html/index.html' },
			{ image: ci22, name: '㈜인터케어', url: 'https://www.intercare.co.kr/' },
			{ image: ci23, name: '라비오', url: 'http://www.labio.kr/' },
			{ image: ci24, name: '아이이씨코리아', url: 'https://www.ieckorea.co.kr/' },
			{ image: ci25, name: '바이오에프디엔씨', url: 'https://biofdnc.com/' },
			{ image: ci31, name: '삼양KCI', url: 'https://www.samyangkci.com/kr/index' },
			{ image: ci30, name: '(주)마크로케어', url: 'http://www.macrocare.net' },
		],
	},
];

interface SponsorLogoSectionProps {
	title?: string;
}

const SponsorLogoSection = ({ title = '특별후원사' }: SponsorLogoSectionProps) => (
	<>
		<S.SpecialTitle>{title}</S.SpecialTitle>
		<S.SponsorGroupList>
			{sponsorGroups.map((group) => (
				<S.SponsorGroup key={group.grade}>
					<S.SponsorGradeTitle className={group.grade.toLowerCase()}>{group.grade}</S.SponsorGradeTitle>
					<S.LogoGrid className={group.grade.toLowerCase()}>
						{group.logos.map(({ image, name, url }, idx) => (
							<S.LogoImgWrapper
								className={`${group.grade.toLowerCase()} ${group.grade === 'Platinum' && idx === 0 ? 'amorepacific' : ''} ${group.grade === 'Gold' && idx === group.logos.length - 1 ? 'j2kbio' : ''} ${group.grade === 'Silver' && idx === 1 ? 'silver-second' : ''} ${group.grade === 'Silver' && ![1, 2, 4, 5].includes(idx) ? 'silver-large' : ''} ${group.grade === 'Bronze' && ![0, 5].includes(idx) ? 'bronze-large' : ''} ${group.grade === 'Bronze' && [1, 3, 6, 11, 14].includes(idx) ? 'bronze-selected' : ''} ${group.grade === 'Bronze' && idx === 3 ? 'bronze-fourth' : ''} ${group.grade === 'Bronze' && idx === 7 ? 'bronze-eighth' : ''} ${group.grade === 'Bronze' && idx === 2 ? 'bronze-third' : ''}`}
								key={`${group.grade}-${idx}`}
								href={url}
								target="_blank"
								rel="noreferrer"
							>
								<S.LogoImg src={image} alt={name} />
							</S.LogoImgWrapper>
						))}
					</S.LogoGrid>
				</S.SponsorGroup>
			))}
		</S.SponsorGroupList>
	</>
);

export default SponsorLogoSection;
